var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"z-index":100000,"color":"#2F3446","opacity":1,"value":(!_vm.authUserGetter && this.$route.name !== 'Login') || _vm.loading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"85"}},[_vm._v("NGA911")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }